/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileSchemaIn } from './FileSchemaIn';
import {
    FileSchemaInFromJSON,
    FileSchemaInFromJSONTyped,
    FileSchemaInToJSON,
} from './FileSchemaIn';

/**
 * 
 * @export
 * @interface FacePhoto
 */
export interface FacePhoto {
    /**
     * 
     * @type {FileSchemaIn}
     * @memberof FacePhoto
     */
    facePhoto?: FileSchemaIn;
}

/**
 * Check if a given object implements the FacePhoto interface.
 */
export function instanceOfFacePhoto(value: object): boolean {
    return true;
}

export function FacePhotoFromJSON(json: any): FacePhoto {
    return FacePhotoFromJSONTyped(json, false);
}

export function FacePhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacePhoto {
    if (json == null) {
        return json;
    }
    return {
        
        'facePhoto': json['face_photo'] == null ? undefined : FileSchemaInFromJSON(json['face_photo']),
    };
}

export function FacePhotoToJSON(value?: FacePhoto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'face_photo': FileSchemaInToJSON(value['facePhoto']),
    };
}

